/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type BUDGET_TYPE = "FIXED_PRICE" | "FIXED_PRICE_V2" | "NON_BILLABLE" | "RETAINER" | "TIME_AND_MATERIALS" | "%future added value";
export type InvoiceDetails_project = {
    readonly budgetType: BUDGET_TYPE | null;
    readonly " $fragmentRefs": FragmentRefs<"InvoiceDetailsTable_project">;
    readonly " $refType": "InvoiceDetails_project";
};
export type InvoiceDetails_project$data = InvoiceDetails_project;
export type InvoiceDetails_project$key = {
    readonly " $data"?: InvoiceDetails_project$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"InvoiceDetails_project">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InvoiceDetails_project",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "budgetType",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InvoiceDetailsTable_project"
    }
  ],
  "type": "ProjectType"
};
(node as any).hash = 'b3091e392030c9087468d1277ed3272c';
export default node;
